import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { BodyText as Text } from 'ui/styles/utils'
import './styles.css'
import theme from 'ui/styles/theme'

export default class Salesmen extends Component {
    constructor(props) {
        super(props);
    }
    state = {}
    render() {
        const {
            salesperson,
            textfield,
            bgcolor
        } = this.props
        return (
            <Wrapper className={"salesman-contact"} bgcolor={bgcolor} >
                <InnerWrapper fluid>
                    <Row>
                        <Col>
                            <Article dangerouslySetInnerHTML={{ __html: textfield }} />
                        </Col>
                    </Row>
                    <CardWrapper>
                        <Row justifyContent="around">
                            {salesperson.map((a, index) =>
                                <Col md={4} key={index} className={"card-column"}>
                                    <Card>
                                        <Picture>
                                            <img src={a.image.sourceUrl} />
                                        </Picture>
                                        <Texta>
                                            <Name>{a.name}</Name>
                                            <Subtitle>{a.subtitle}</Subtitle>
                                            <Contact>
                                                <Ext>Ext.: {a.contact_info[0].ext}</Ext>
                                                <Mobile>Mobile: {a.contact_info[0].mobile}</Mobile>
                                                <Email>{a.contact_info[0].email}</Email>
                                            </Contact>
                                            <Break />
                                            <Linkedin>
                                                <p>Connect with {a.name.includes(' ') ? a.name.substring(0, a.name.indexOf(' ')) : a.name}</p>
                                                <a href={a.linkedin_url}  target="_blank">LinkedIn</a>
                                            </Linkedin>
                                        </Texta>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </CardWrapper>
                </InnerWrapper>
            </Wrapper >
        )
    }
}

//Styles
const Wrapper = styled.div`
padding: 0 20px;
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
`
const InnerWrapper = styled(Container)`
padding: 0 20px;
${media.lg`
padding: 0 20%;
`}
`
const Article = styled(Text)`
overflow: hidden;
display: -webkit-box;
-webkit-line-clamp: ${props => props.lines};
-webkit-box-orient: vertical;
-webkit-mask-image: linear-gradient(180deg, black ${props => props.lines !== undefined ? '' : '100%'}, transparent);
transition: all 400ms;
h2{
    margin-bottom: 0 !important;
}
`

const CardWrapper = styled.section`
`
const TextField = styled.div`
color: #004077;
h2{
    margin-bottom: 0 !important;
}
`

const Card = styled.div`
    background-color: white;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    border-radius: 5px
    color: #004077;
    margin: 1.2em 0;
`
const Picture = styled.div`
img {
    width: 100%;
    border-radius: 5px 5px 0px 0px;
    object-fit: cover;
}
`
const Texta = styled.div`
display: flex;
flex-direction: column;
justify-content: space-evenly;
padding: 10px;
height: 420px;

${media.xl`
padding-left: 2em;
padding-right: 2em;
height: 400px;
`}


`
const Name = styled.p`
color: #004077;
text-transform: uppercase;
margin-bottom: 0;
font-size: 1.22em;
font-weight: 400;
${media.md`

`}
${media.lg`

`}


`
const Subtitle = styled.p`
font-weight: 500;
margin-bottom: 30px;
${media.md`

`}
${media.lg`

`}
`
const Contact = styled.div`
${media.md`

`}
${media.lg`

`}
p{
    margin-bottom: 0;
}
`
const Ext = styled.p``
const Mobile = styled.p``
const Email = styled.p``
const Break = styled.hr`
display: block;
height: 1px;
border: 0;
border-top: 1px solid #ccc;
margin: 1em 0;
padding: 0;
margin-top: 30px;
`
const Linkedin = styled.div`
padding-bottom: 20px;
${media.md`

`}
${media.lg`

`}

a{
    background-color:#0077B5;
    padding: 5px 20px 5px 20px;
    color: white;
    border-radius: 20px;
    text-decoration: none;
    transition: all .2s ease-in-out;
}

a:hover{
    color: white;
    background-color: #0291db;
}



`


// WEBPACK FOOTER //
// ./src/ui/components/modules/Salesmen/index.js